import React, { Component } from "react";
import "./Button.scss";
import Isvg from 'react-inlinesvg'

class Button extends Component {
  render() {
    let icon = null
    if (this.props.icon) {
      icon = <Isvg src={this.props.icon} />
    }
    return (
      <button
        type={this.props.type || 'button'}
        className={`btn ${ this.props.name }` }
        style={this.props.style}
        onClick={event => this.props.onClick()}>
        {icon}
        {this.props.text}
      </button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Commons/Button.js